module.exports = __webpack_public_path__ + "img/symbol_13.62fdc624.png";